import { Card, Col, Divider, Row, Space, Button } from "antd";
import { Form, Formik } from "formik";

import {
  DatePicker,
  InputNumber,
  Select,
  Switch,
  TimePicker,
} from "components/form";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import schema from "../../../features/company/schemas/companyWorkCondSchema";

// import { formatDayMonth } from "utils/formatter";
import styles from "../styles/CompanyProfile.module.css";
import { Footer } from "antd/es/layout/layout";
import { useState } from "react";
import { FormDatePicker } from "components/form/FormProvide";

function CompanyWorkingEdit({
  isLoading = false,
  initialValues = {},
  shiftConditionChangeOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
}) {


  function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD/MM/YYYY" }) {
    if (!dateString) return;
    const date = dayjs(dateString, pattern);
    return date.format(reFormat);
  }

  const { t, i18n } = useTranslation();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue }) => {
        return (
          <Form>
            <Space className={styles.container} size={24} direction="vertical">
              <Card style={{ border: "solid 1px #EAECF0" }}>
                <b className={styles.infoTopic}>
                  {t("working_condition.label.working_hours_and_statuses")}
                </b>
                <p>{t("working_condition.label.description1")}</p>
                <Divider />
                <Row gutter={[24, 16]}>
                  <Col span={12}>
                    <TimePicker
                      name="workingHours"
                      label={t("working_condition.label.working_hours")}
                      size="large"
                      required
                      format="HH:mm"
                    />
                  </Col>
                  <Col span={12}>
                    <DatePicker
                      name="yearEndDate"
                      label={
                        t("working_condition.label.year_end_date")
                      }
                      placeholder={
                        t("working_condition.label.year_end_date")
                      }
                      size="large"
                      format='DD/MM/YYYY'
                      required

                    />
                  </Col>
                  <Col span={12}>
                    <Switch
                      name="baseOnShifts"
                      label={t(
                        "working_condition.label.based_working_in_shift"
                      )}
                    />
                  </Col>
                  <Col span={12}>
                    <Switch
                      name="checkOutByLocation"
                      label={t(
                        "working_condition.label.clock_out_by_shift"
                      )}
                    />
                  </Col>
                  <Col span={12}>
                    <InputNumber
                      name="lateTime"
                      label={
                        t("working_condition.label.mark_late")
                      }
                      size="large"
                      required
                      // max={60}
                      min={0}
                      format="HH:mm"
                      precision={0}
                      controls={false}
                      textAlign="left"
                    />
                  </Col>
                  <Col span={12}>
                    <InputNumber
                      name="absentTime"
                      label={
                        t("working_condition.label.mark_absent")
                      }
                      size="large"
                      required
                      // max={60}
                      format="HH:mm"
                      min={0}
                      precision={0}
                      controls={false}
                      textAlign="left"
                    />
                  </Col>
                </Row>
              </Card>
              <Card style={{ border: "solid 1px #EAECF0" }}>
                <b className={styles.infoTopic}>
                  {t("working_condition.label.shift")}
                </b>
                <p>{t("working_condition.label.description2")}</p>
                <Divider />
                <Row gutter={[24, 24]}>
                  <Col span={12}>
                    <Select
                      required
                      name="shiftConditionChange"
                      label={t(
                        "working_condition.label.condition_shift_change"
                      )}
                      size="large"
                      options={shiftConditionChangeOptions}
                    />
                  </Col>
                  <Col span={12}>
                    <InputNumber
                      // suffix={t("unit.days")}
                      name="shiftDateChange"
                      label={t("working_condition.label.backdate_within")}
                      placeholder={t("working_condition.label.backdate_within")}
                      size="large"
                      min={0}
                      disabled={['SHIFT_CHANGE_02', 'SHIFT_CHANGE_03'].includes(shiftConditionChangeOptions?.find?.(o => o.value == values?.shiftConditionChange)?.code)}
                      controls={false}
                      // textAlign="Left"
                      precision={0}
                      textAlign="left"
                    />
                  </Col>
                  <Col span={12}>
                    <Switch
                      name="supvAnyTimeShiftChange"
                      label={t("working_condition.label.shift_changable")}
                    />
                  </Col>
                  <Col span={12}>
                    <Switch
                      name="onlyEmployeeNormalStatus"
                      label={t("working_condition.label.only_normal_employee")}
                    />
                  </Col>
                  <Col span={12} />
                </Row>
              </Card>
              <Card style={{ border: "solid 1px #EAECF0" }}>
                <b className={styles.infoTopic}>
                  {t("working_condition.label.probation")}
                </b>
                <p>{t("working_condition.label.description3")}</p>
                <Divider />
                <Row gutter={[24, 16]}>
                  <Col span={12}>
                    <InputNumber
                      // suffix={t("unit.days")}
                      name="prorateLeaveIfBefore"
                      label={t("working_condition.label.prorate_if_before")}
                      placeholder={`${t("working_condition.label.prorate_if_before")} (${t("unit.days")})`}
                      size="large"
                      stringMode
                      min={0}
                      max={31}
                      required
                      controls={false}
                      precision={0}
                      textAlign="left"
                    />
                  </Col>
                  <Col span={12}>
                    <InputNumber
                      // suffix={t("unit.days")}
                      name="dayOfProbation"
                      label={t("working_condition.label.days_of_probation")}
                      placeholder={t("working_condition.label.days_of_probation")}
                      size="large"
                      stringMode
                      min={0}
                      controls={false}
                      precision={0}
                      textAlign="left"
                    />
                  </Col>
                  <Col span={12}>
                    <Switch
                      name="halfProrateFromDay"
                      label={
                        <span>
                          {t("working_condition.label.allow_half_prorate_from")}{" "}
                          <b>{values?.prorateLeaveIfBefore}</b>
                        </span>
                      }
                    />
                  </Col>
                  <Col span={12} />
                </Row>
              </Card>
              <Card style={{ border: "solid 1px #EAECF0" }}>
                <b className={styles.infoTopic}>
                  {t("working_condition.label.retire")}
                </b>
                <p>{t("working_condition.label.description4")}</p>
                <Divider />
                <Row gutter={[24, 16]}>
                  <Col span={12}>
                    <InputNumber
                      // suffix={t("unit.years")}
                      name="maleRetirementAge"
                      label={`${t("working_condition.label.male_retriement")} (${t("unit.years")})`}
                      placeholder={`${t("working_condition.label.male_retriement")} (${t("unit.years")})`}
                      size="large"
                      stringMode
                      min={0}
                      max={100}
                      controls={false}
                      precision={0}
                      textAlign="left"
                    />
                  </Col>
                  <Col span={12}>
                    <InputNumber
                      // suffix={t("unit.years")}
                      name="femaleRetirementAge"
                      label={`${t("working_condition.label.female_retriement")} (${t("unit.years")})`}
                      placeholder={`${t("working_condition.label.female_retriement")} (${t("unit.years")})`}
                      size="large"
                      stringMode
                      min={0}
                      max={100}
                      controls={false}
                      precision={0}
                      textAlign="left"
                    />
                  </Col>
                </Row>
              </Card>
              <Card style={{ border: "solid 1px #EAECF0" }}>
                <b className={styles.infoTopic}>
                  {t("working_condition.label.separation")}
                </b>
                <p>{t("working_condition.label.description5")}</p>
                <Divider />
                <Row gutter={[24, 16]}>
                  <Col span={12}>
                    <InputNumber
                      // suffix={t("unit.days")}
                      name="countLastMonthBeforeLastWorkday"
                      label={`${t("working_condition.label.count_as_last_month")} (${t("unit.days")})`}
                      placeholder={`${t("working_condition.label.count_as_last_month")} (${t("unit.days")})`}
                      size="large"
                      stringMode
                      min={0}
                      controls={false}
                      precision={0}
                      textAlign="left"
                    />
                  </Col>
                </Row>
              </Card>
            </Space>
            <Footer style={{
              zIndex: 999,
              bottom: 1,
              position: 'sticky',
              backgroundColor: 'white',
              // backdropFilter: 'blur(90px)',
              // borderRadius: '10rem',
              height: "fit-content",
              // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              padding: '10px 50px',
              // display: 'flex',
              // justifyContent: 'end',
              // alignItems: 'center',
            }}>
              <Row justify="end" >
                <Space>
                  <Button type="default" onClick={() => {
                    onCancel();
                  }}
                    style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                  >
                    {t("common.cancel").toUpperCase()}
                  </Button>
                  <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                    {t("common.submit").toUpperCase()}
                  </Button>
                </Space>
              </Row>
            </Footer>
          </Form>
        );
      }}
    </Formik>
  );
}

export default CompanyWorkingEdit;
